export default class NotNull {
  constructor() {
    'ngInject';

    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    ctrl.$validators.notNull = modelValue => true && modelValue;
  }

  static directiveFactory() {
    'ngInject';

    return new NotNull();
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/not-null.js